export default __webpack_public_path__ + "static/media/icon-image-add.f30eb7b4.svg";